/**
 * Scroll inline Webform AJAX confirmations into view after submit.
 *
 * Webform replaces the form in-place when ajax is enabled; this ensures the
 * success message is visible without a full page reload (newsletter, contact,
 * partner forms, etc.).
 */
export function initZkWebformAjaxConfirm() {
  const CONFIRMATION_SELECTOR = [
    '.webform-confirmation',
    '.webform-confirmation__message',
    '.zk-newsletter__confirmation',
    '.zk-webform-confirmation',
    '.zk-community-suggestion-confirmation',
  ].join(', ');

  const revealConfirmation = (scope) => {
    const root = scope && scope.querySelector ? scope : document;
    const target = root.querySelector(CONFIRMATION_SELECTOR);
    if (!target) {
      return;
    }

    window.setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }
      target.focus({ preventScroll: true });
    }, 80);
  };

  if (typeof window.jQuery === 'undefined') {
    return;
  }

  window.jQuery(document).on('ajaxSuccess.zkWebformConfirm', (event, xhr, settings) => {
    const url = settings?.url ? String(settings.url) : '';
    if (!url.includes('webform')) {
      return;
    }

    const trigger = settings.element;
    const scope =
      trigger?.closest?.('.zk-newsletter-webform') ||
      trigger?.closest?.('form.webform-submission-form') ||
      trigger?.closest?.('[id^="webform-submission"]') ||
      document;

    revealConfirmation(scope);
  });
}
